import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import WatchCommon from '../Common/saga';
import WatchUser from '../User/saga';
import WatchSubcontractor from '../Subcontractors/saga';
import WatchRoom from '../Rooms/saga';
import WatchAuth from '../Auth/saga';
import WatchBuilder from '../Builders/saga';
import WatchTrade from '../Trades/saga';
import WatchItemRepair from '../Items/saga';
import WatchGlobalSearch from '../Search/saga';
import WatchWorkOrder from '../Work-Orders/saga';

export default function* rootSaga() {
  yield all([
    WatchCommon(),
    WatchUser(),
    WatchSubcontractor(),
    WatchRoom(),
    WatchAuth(),
    WatchBuilder(),
    WatchTrade(),
    WatchWorkOrder(),
    WatchItemRepair(),
    WatchGlobalSearch()
  ]);
}



// WEBPACK FOOTER //
// ./src/portal_system/saga.js